import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      height: 300,
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),

      '& .recharts-cartesian-grid-horizontal line': {
        stroke: '#EFEFEF',
      },

      '& .recharts-cartesian-axis-tick-value': {
        fontSize: theme.typography.pxToRem(10),
        fill: '#8E969D',
      },

      '& .recharts-legend-item-text': {
        fontSize: theme.typography.pxToRem(12),
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 600,
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'UserActivityChart' }
);
